var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"p-5"},[_c('div',{staticClass:"vx-row mb-3"},[_c('div',{staticClass:"vx-col w-full"},[_c('p',[_vm._v("null")])])])])}]

export { render, staticRenderFns }